import React    from 'react';
import {render} from 'react-dom';

class SimpleGallery extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      image_urls: props.image_urls,
      activeIndex: 0
    }
  }
  render() {
    let {activeIndex, image_urls} = this.state;

    return(
      <div id="simplegallery">
        <div className="hidden-xs">
          <div className="col-img-main">
            <img alt="car" className="img-responsive" id="img-main" src={image_urls[activeIndex]} />
          </div>
          <br />
          <div className="row">
            {thumbItems.call(this)}
          </div>
        </div>
        <div className="visible-xs">
          <div className="carousel slide" data-ride="carousel" id="img-carousel">
            <ol className="carousel-indicators">
              {smallThumbItems.call(this)}
            </ol>
            <div className="carousel-inner">
              {smallImages.call(this)}
            </div>
            <a className="left carousel-control" data-slide="prev" href="#img-carousel"><span className="glyphicon glyphicon-chevron-left"></span></a><a className="right carousel-control" data-slide="next" href="#img-carousel"><span className="glyphicon glyphicon-chevron-right"></span></a>
          </div>
        </div>
      </div>
    )
  }
}

let smallImages = function() {
  let items = []

  items = this.state.image_urls.map((imageUrl, index) => {
    return (
      <div key={index} className={index == 0 ? "item active" : "item"}>
        <img className="img-responsive" src={imageUrl} />
      </div>
    )
  })

  return items
}

let smallThumbItems = function() {
  let items = []

  items = this.state.image_urls.map((imageUrl, index) => {
    return (
      <li key={index} className={index == 0 ? "active" : ""} data-slide-to={index} data-target="#img-carousel"></li>
    )
  })

  return items
}

let thumbItems = function() {
  let items = []

  items = this.state.image_urls.map((imageUrl, index) => {
    return (
      <div key={index} className="col-xs-3 col-sm-2 row-spacing-small">
        <img alt="car" className="img-responsive img-small center-block" onClick={setSelectedItem.bind(this, index)} src={imageUrl} />
      </div>
    )
  })

  return items
}

let setSelectedItem = function(index) {
  this.setState({activeIndex: index})
}

export default SimpleGallery;
